<h2 class="item-page-title-field">
  <div *ngIf="item.firstMetadataValue('dspace.entity.type') as type" class="d-inline">
    {{ type.toLowerCase() + '.page.titleprefix' | translate }}
  </div>
  <span class="dont-break-out">{{ dsoNameService.getName(item) }}</span>
</h2>
